export enum SapOperationType {
  CATALOGUES = 'catalogues',
  INVENTORY = 'inventory',
  PRICING = 'pricing',
}

/**
 * Enum: SapLogStatus
 */
export enum SapLogStatus {
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAILED = 'failed',
}
